export const LANGUAGE = {
  EN: 'en',
  ES: 'es',
  PT: 'pt',
} as const;

export type Language = (typeof LANGUAGE)[keyof typeof LANGUAGE];
export const availableLanguages = Object.values(LANGUAGE);

export function isLanguage(value: unknown): value is Language {
  return typeof value === 'string' && availableLanguages.includes(value as Language);
}
